module.exports = __webpack_public_path__ + "202669:9205d1a92be8207f1496/img/mobile-phones@1x.f32a742.png";